/**
 * What a commercial-outcome row's figures count: every product, or only the
 * campaign's / landing page's product scope — its marketing categories
 * and/or product keywords (an order must match both when both are set). See
 * docs/features/campaign-results-enrichment/13_marketing_category_scoping.md.
 */

import {
  SELECTABLE_MARKETING_CATEGORIES,
  type MarketingCategory,
} from "../data/marketing-types";

export interface ProductScope {
  productKeywords: string[] | null;
  categories: MarketingCategory[] | null;
}

export function isProductScoped(scope: ProductScope): boolean {
  return (
    (scope.productKeywords?.length ?? 0) > 0 ||
    (scope.categories?.length ?? 0) > 0
  );
}

/** "All products", "Merch, Clothing & workwear", `Products matching
 * "advent"`, or `Merch matching "mug", "cup"` when both are set. */
export function describeProductScope(scope: ProductScope): string {
  const categories = (scope.categories ?? []).map(categoryLabel);
  const keywords = (scope.productKeywords ?? []).map((k) => `"${k}"`);
  if (categories.length === 0 && keywords.length === 0) return "All products";
  if (keywords.length === 0) return categories.join(", ");
  const subject = categories.length > 0 ? categories.join(", ") : "Products";
  return `${subject} matching ${keywords.join(", ")}`;
}

export function categoryLabel(category: MarketingCategory): string {
  return (
    SELECTABLE_MARKETING_CATEGORIES.find((c) => c.value === category)?.label ??
    capitalise(category)
  );
}

function capitalise(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
